module.exports = __webpack_public_path__ + "assets/img/block-right-hover-9d1596b0.png";